import React from "react";
import style from "./SaasActionBar.module.css";
import { formatMoney } from "accounting-js";
import QuantityInput from "../QuantityInput";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { setQty } from "../../redux/actions";

const SaasActionBar = ({
  name,
  saasTargetPrice,
  saasotherprice,
  canAddToCart,
  handleAddToQuote,
  isUpdate,
  qty,
  setQty,
  canChangeQuantity
}) => {
  return (
    <div className={style.root}>
      <div className={style.inner}>
        <span className={style.config}>Configure {name}</span>

        <div className={style.priceContainer}>
          <span className={style.priceLabel}>Saas Total for Term:</span><span className={style.price}>{formatMoney(saasTargetPrice)}</span>
          <span className={style.priceLabel}>Other Products Total:</span><span className={style.price}>{formatMoney(saasotherprice)}</span>
        </div>

        <InputGroup className={style.inputGroup}>
          <FormControl
            as={QuantityInput}
            type="number"
            value={qty}
            onConfirm={e => setQty(e.target.value)}
            disabled={!canChangeQuantity}
          />

          <InputGroup.Append>
            <Button
              title="Add to Quote"
              onClick={handleAddToQuote}
              disabled={!canAddToCart}
            >
              {isUpdate ? "Update Quote" : "Add to Quote"}
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </div>
    </div>
  );
}

export default connect(
  ({ product }) => ({ qty: product.qty }), 
  { setQty })
  (SaasActionBar);
